module.exports = __webpack_public_path__ + "img/picture-elena-2.ef9f2151.png";